import React from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import "../../../styles/basicModal.scss"

export default function BasicModal(props) {
  const { popupOpen, bodyMessage, popupCloseHandler, heading, footer, logo, customcss, isCross, popupSize, bodyElementMargin } = props;

  return (
    <div>
      <Modal
        open={popupOpen}
        onClose={popupCloseHandler}
        className="basic-modal"
      >

        <div className={`basic-modal_root ${props?.popupSize?props?.popupSize:'col-4'} ${customcss ? "custom_modal_overiride" : ""}`}>
         
          <div className="basic-modal_main">
            {heading && <div className="basic-modal_root_main_header">
              <h6>{heading}</h6>
              {isCross && <span onClick={popupCloseHandler}>X</span>}
              </div>}
            {bodyMessage && <div className="basic-modal_root_main_body">
              {logo && <p><img src={logo} alt="logo" style={{ width: "50px" }} /></p>}
              <p className={`${bodyElementMargin}`}>{bodyMessage}</p>
            </div>}
            <div className={`basic-modal_root_main_footer ${props?.popBtnAlignment}`}>
              {footer?.thirdButton && <button type="button" className={`${footer?.thirdButton?.buttonThirdCustomCss ? footer?.thirdButton?.buttonThirdCustomCss : ''} clear-btn`} onClick={footer?.thirdButton?.action}>{footer?.thirdButton?.buttonName}</button>}
              {footer?.primaryButton && <button type="button" className={`${footer?.primaryButton?.buttonPrimaryCustomCss ? footer?.primaryButton?.buttonPrimaryCustomCss : ''} btn-cancel`} onClick={footer?.primaryButton?.action}>{footer?.primaryButton?.buttonName}</button>}
              {footer?.secondaryButton && <button type="button" className={`${footer?.secondaryButton?.buttonSecondaryCustomCss ? footer?.secondaryButton?.buttonSecondaryCustomCss : ''} btn-success`} onClick={footer?.secondaryButton?.action}>{footer?.secondaryButton?.buttonName}</button>}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
